module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "usersAdd"
  }, [_c('el-breadcrumb', {
    staticClass: "bread-nav",
    attrs: {
      "separator": "/"
    }
  }, [_c('el-breadcrumb-item', [_vm._v("首页")]), _vm._v(" "), _c('el-breadcrumb-item', [_vm._v("用户管理")]), _vm._v(" "), _c('el-breadcrumb-item', [_vm._v("添加用户")])], 1), _vm._v(" "), _c('el-form', {
    ref: "addUserForm",
    staticClass: "addUserForm",
    attrs: {
      "model": _vm.addUserForm,
      "rules": _vm.validateRules,
      "label-width": "100px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "邮箱",
      "prop": "accountEmail"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请填写一点资讯邮箱，如：xxx@yidian-inc.com"
    },
    model: {
      value: (_vm.addUserForm.accountEmail),
      callback: function($$v) {
        _vm.addUserForm.accountEmail = $$v
      },
      expression: "addUserForm.accountEmail"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "密码",
      "prop": "password"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "password",
      "auto-complete": "off",
      "placeholder": "请填写长度不少于6位的密码"
    },
    model: {
      value: (_vm.addUserForm.password),
      callback: function($$v) {
        _vm.addUserForm.password = $$v
      },
      expression: "addUserForm.password"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "确认密码",
      "prop": "confirmPassword"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "password",
      "auto-complete": "off",
      "placeholder": "请再次填写密码"
    },
    model: {
      value: (_vm.addUserForm.confirmPassword),
      callback: function($$v) {
        _vm.addUserForm.confirmPassword = $$v
      },
      expression: "addUserForm.confirmPassword"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "姓名",
      "prop": "userName"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请填写用户真实姓名"
    },
    model: {
      value: (_vm.addUserForm.userName),
      callback: function($$v) {
        _vm.addUserForm.userName = $$v
      },
      expression: "addUserForm.userName"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "权限",
      "prop": "permissionId"
    }
  }, [_c('el-select', {
    staticClass: "form-select",
    attrs: {
      "placeholder": "请选择用户权限"
    },
    model: {
      value: (_vm.addUserForm.permissionId),
      callback: function($$v) {
        _vm.addUserForm.permissionId = $$v
      },
      expression: "addUserForm.permissionId"
    }
  }, _vm._l((_vm.permissionList), function(permissionItem) {
    return _c('el-option', {
      key: permissionItem.permissionsId,
      attrs: {
        "label": permissionItem.permissionsName,
        "value": permissionItem.permissionsId
      }
    })
  }))], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.addUser('addUserForm')
      }
    }
  }, [_vm._v("立即创建")]), _vm._v(" "), _c('el-button', {
    on: {
      "click": _vm.clearUserData
    }
  }, [_vm._v("重置")])], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?{"id":"data-v-0c3b5b99"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/content/users/Add.vue
// module id = 731
// module chunks = 1